<template>
  <div>
    <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden"  id="modal-xl" size="xl" >
      <template slot="modal-header">
        Duplicate item(s) uploaded
      </template>
      <template >

        <div>Some of the media uploaded are already present in the system and the duplicates were deleted<br />
          But the tracks are well linked to the selected box(es)
        </div><br />
      </template>
      <template >
        <div class="table-container">
          <table class="w-100">
            <thead class="border-bottom">
            <tr>
              <th>File</th>
              <th>Title</th>
              <th>Artist</th>
              <th>Creation</th>
            </tr>
            </thead>
                <tr v-for="track in items" v-if="items">
                  <td class="py-2">
                    <div>{{ track.name }}</div>
<!--                    <div class="small">-->
<!--                      <ArtistBadgeList-->
<!--                          :artists="track.artists"-->
<!--                          :simpleText="true"-->
<!--                          :showHidden="false"-->
<!--                      ></ArtistBadgeList>-->
<!--                    </div>-->
                  </td>
                  <td class="py-2">
                    <div>{{ track.item.title }}</div>
                  </td>
                  <td class="py-2">
                    <div>{{ track.item.artist }}</div>
                  </td>
                  <td class="py-2">
                    <div>{{ track.item.creationDate }}</div>
                  </td>
                </tr>
          </table>
        </div>
      </template>
      <template slot="modal-footer">
        <div>
          <Button
              v-show="showCancelBtn"
              :empty="true"
              class="close-popup"
              @click.prevent="hideModal"
          > Ok </Button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Bootstrap from "bootstrap-vue";
import Button from "@/components/common/Button";
import ArtistBadgeList from "@/components/common/ArtistBadgeList";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";

export default {
  name: "DuplicateItems",
  components: {
    Bootstrap,
    Button,
    ArtistBadgeList,
  },
  data() {
    return {
      showCancelBtn: true
    };
  },
  props: {
    showModalStatus: Boolean,
    items: null
  },
  methods: {
    showModal() {
      this.$refs['modal'].show()
    },
    hideModal() {
      this.$refs['modal'].hide()
    },
    onModalHidden() {
      EventBus.$emit('onDuplicateItemsEnded');
    }
  },
  computed: {
    Translations: function () {
      return Translations;
    },
  },
  watch: {
    showModalStatus: function () {
      this.showModal();
    }

  }
}
</script>
<style>
.modal .modal-content .modal-body{
  flex-direction: column;
}
</style>
